let swiper;

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".our_customer_col.swiper");

  if (sliders.length > 0) {
    sliders.forEach((slider) => {
      const swiperInstance = new Swiper(slider, {
        slidesPerView: 3,
        spaceBetween: 18,
        loop: false,
        navigation: {
          nextEl: ".testimonial_arrow_next",
          prevEl: ".testimonial_arrow_prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: false,
          },
          601: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: false,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false,
          },
        },
        on: {
          init(swiper) {
            updateProgress(swiper);
          },
          slideChange(swiper) {
            updateProgress(swiper);
          },
        },
      });

      function updateProgress(swiper) {
        // Find the progress fill in the same section as the current swiper
        const wrapper = slider.closest(".our_customer_wrapper");
        const fill = wrapper.querySelector(".swiper-progress-fill");

        if (!fill) return;

        // Calculate total visible slides range correctly (no loop)
        const totalSlides = swiper.slides.length;
        const visibleCount = swiper.params.slidesPerView;
        const progressMax = totalSlides - visibleCount;
        const progress = swiper.activeIndex / (progressMax <= 0 ? 1 : progressMax);
        const progressPercent = Math.min(Math.max(progress * 100, 0), 100);

        fill.style.width = `${progressPercent}%`;
      }
    });
  }


document.querySelectorAll(".pdp_faq_wrapper").forEach(function (section) {
  var faqHeadings = section.querySelectorAll(".block_faq__right_heading");
  
  faqHeadings.forEach(function (heading) {
    heading.addEventListener("click", function () {
      var parentBox = heading.closest(".block_faq_right_box_in");

      if (heading.classList.contains("active")) {
        heading.nextElementSibling.style.display = "none";
        heading.classList.remove("active");
        if (parentBox) parentBox.classList.remove("active");
      } else {
        // Remove active from all
        section.querySelectorAll(".block_faq_right_info").forEach(function (info) {
          info.style.display = "none";
        });
        section.querySelectorAll(".block_faq__right_heading").forEach(function (h) {
          h.classList.remove("active");
        });
        section.querySelectorAll(".block_faq_right_box_in").forEach(function (box) {
          box.classList.remove("active");
        });

        // Add active to current
        heading.nextElementSibling.style.display = "block";
        heading.classList.add("active");
        if (parentBox) parentBox.classList.add("active");
      }
    });
  });
});



document.querySelectorAll('.download_tab_col li').forEach(function(item) {
    item.addEventListener('click', function() {
        var tabId = this.getAttribute('data-tab');

        // Remove active from all tabs
        document.querySelectorAll('.download_tab_col li').forEach(function(li) {
            li.classList.remove('active');
        });

        // Remove active from all bottom boxes
        this.closest('.download_tab_wrapper').querySelectorAll('.download_tab_bottom_box').forEach(function(product) {
            product.classList.remove('active');
        });

        // Add active to clicked tab
        this.classList.add('active');

        // Add active to all bottom boxes with matching data-tab
        this.closest('.download_tab_wrapper')
            .querySelectorAll(`.download_tab_bottom_box[id="${tabId}"]`)
            .forEach(function(box) {
                box.classList.add('active');
            });
    });
});



// Video GAllery Sldier js
const fourzeroSlider = document.querySelectorAll(
    ".video_gallery_col.swiper"
  );
  fourzeroSlider &&
    fourzeroSlider.forEach((four__widget) => {
      new Swiper(four__widget, {
        slidesPerView: 1.5,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: ".video_gallery_next_icon",
          prevEl: ".video_gallery_prev_icon",
        },
        breakpoints: {
          320: {
            slidesPerView: "1.1",
            spaceBetween: 16,
          },
          768: {
            slidesPerView: "1.3",
            spaceBetween: 20,
          },
        },
      });
    });




function setUniformMediaHeight() {
  const mediaWrappers = document.querySelectorAll('.video_gallery_col .swiper-slide .video_gallery_video_inner');
  let maxHeight = 0;

  // Reset first
  mediaWrappers.forEach(wrapper => {
    wrapper.style.height = 'auto';
    const media = wrapper.querySelector('img, video');
    if (media) {
      maxHeight = Math.max(maxHeight, media.offsetHeight);
    }
  });

  // Apply uniform height
  mediaWrappers.forEach(wrapper => {
    wrapper.style.height = `${maxHeight}px`;
  });

  //swiper.update();
}

// Run on load and resize
window.addEventListener('load', setUniformMediaHeight);
window.addEventListener('resize', setUniformMediaHeight);
    


  const carouselList = document.querySelector(".xo-product-info-media-carousel__list");
  const slides = carouselList?.querySelectorAll("xo-carousel-slide");
  const dotsContainer = document.querySelector(".xo-media-carousel-dots");

  if (!carouselList || !slides?.length || !dotsContainer) return;

  // Clear old dots
  dotsContainer.innerHTML = "";

  // Create dots
  slides.forEach((_, index) => {
    const dot = document.createElement("span");
    dot.className = "xo-media-dot";
    if (index === 0) dot.classList.add("active");
    dot.dataset.index = index;
    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll(".xo-media-dot");
  let currentIndex = 0;

  const updateDots = (index) => {
    dots.forEach((d, i) => d.classList.toggle("active", i === index));
  };

  // Click on dot → slide moves
  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      currentIndex = Number(dot.dataset.index);
      const slideWidth = carouselList.querySelector("xo-carousel-slide").offsetWidth;
      carouselList.style.transform = `translate3d(-${currentIndex * slideWidth}px, 0, 0)`;
      updateDots(currentIndex);
    });
  });

  // ✅ Use a unique name for the observer
  const carouselObserver = new MutationObserver(() => {
    const style = carouselList.style.transform;
    const match = style.match(/-([\d.]+)px/);
    if (match) {
      const pos = parseFloat(match[1]);
      const slideWidth = carouselList.querySelector("xo-carousel-slide").offsetWidth;
      const newIndex = Math.round(pos / slideWidth);
      updateDots(newIndex);
    }
  });

  // Observe changes in transform (for swiping / arrow nav)
  carouselObserver.observe(carouselList, { attributes: true, attributeFilter: ["style"] });








  const initMediaViewMore = () => {
    const thumbSlides = document.querySelectorAll(".xo-product-info-media-carousel__thumb-slide");
    const viewMoreBtn = document.querySelector(".xo-product-info-media-carousel__thumb-slide_more_btn");

    if (!thumbSlides.length || !viewMoreBtn) return;

    // Reset default state
    thumbSlides.forEach((slide, index) => {
      slide.style.display = index < 5 ? "block" : "none";
    });

    if (thumbSlides.length > 5) {
      viewMoreBtn.style.display = "flex";
      viewMoreBtn.onclick = function () {
        thumbSlides.forEach((slide) => (slide.style.display = "block"));
        viewMoreBtn.style.display = "none";
      };
    } else {
      viewMoreBtn.style.display = "none";
    }
  };

  // Run on initial load
  initMediaViewMore();

  // Detect when theme dynamically updates media section (variant change)
  const observer = new MutationObserver(() => {
    // If new thumbnails are injected, re-run logic
    if (document.querySelectorAll(".xo-product-info-media-carousel__thumb-slide").length) {
      initMediaViewMore();
    }
  });

  // Observe the main product media container
  const target = document.querySelector(".xo-product-info-media-carousel");
  if (target) {
    observer.observe(target, { childList: true, subtree: true });
  }

  // Also run when Shopify reloads a section (theme editor)
  document.addEventListener("shopify:section:load", initMediaViewMore);




  
});



// Fix: Clear xo-unavailable for products with redirect-based variants
(function () {
  function fixVariantUnavailable() {
    var productEl = document.querySelector('xo-product[xo-product-information]');
    if (!productEl) return;
    if (
      !productEl.hasAttribute('xo-unavailable') ||
      productEl.getAttribute('xo-unavailable') === 'false'
    ) {
      return;
    }

    // Check if the product has available variants
    var cartAddEl = productEl.querySelector('xo-cart-add.xo-product-info-content__add');
    if (!cartAddEl || cartAddEl.hasAttribute('xo-disabled')) return;

    // Remove the xo-unavailable attribute so the button works normally
    productEl.setAttribute('xo-unavailable', 'false');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(fixVariantUnavailable, 300);
    });
  } else {
    setTimeout(fixVariantUnavailable, 300);
  }
})();

  function equl(name) {
  let heading = document.querySelectorAll(name);
  let titleHeight = 0;
  heading.forEach((title) => {
    let matchHeight = title.clientHeight;
    if (matchHeight > titleHeight) {
      titleHeight = title.clientHeight;
    }
  });
  heading.forEach((divHeight) => {
    divHeight.style.minHeight = titleHeight + "px";
  });
}
document.addEventListener("DOMContentLoaded", function (event) {
  setTimeout(() => {
    equl(".pdp_feature_icon_box_in");
    equl(".xo-product-card__header .xo-product-image");
  }, 500);
});
